import React, { useState, useEffect, useContext } from 'react';
import { getApiUrl, getDecodedCookie } from '../../helpers/helperApp';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Cookies from 'universal-cookie';
import swal from 'sweetalert';
import { Spinner } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import ListGroup from 'react-bootstrap/ListGroup';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

function SupplierReferences({ articleId, articleName, onUpdate }) {
    const [allSuppliers, setAllSuppliers] = useState([]);

    // Estado para la lista de proveedores asociados al artículo
    const [supplierReferences, setSupplierReferences] = useState([]);

    // Estado para el formulario de nuevo proveedor
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedSupplier, setSelectedSupplier] = useState(null);
    const [referenceValue, setReferenceValue] = useState('');
    const [descriptionValue, setDescriptionValue] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [showSuggestions, setShowSuggestions] = useState(false);

    // --- NUEVOS ESTADOS PARA EL BUSCADOR DE REFERENCIAS ---
    const [supplierRefs, setSupplierRefs] = useState([]); 
    const [refSearchTerm, setRefSearchTerm] = useState('');
    const [selectedRef, setSelectedRef] = useState(null);
    const [showRefSuggestions, setShowRefSuggestions] = useState(false); 
    const [isRefLoading, setIsRefLoading] = useState(false); 
    // --- ESTADOS PARA LA PAGINACIÓN DE REFERENCIAS ---
    const [refPage, setRefPage] = useState(1);
    const [totalRefPages, setTotalRefPages] = useState(1);

    // Efecto para buscar referencias con debounce
    useEffect(() => {
        if (!selectedSupplier) return;

        // Si el término de búsqueda está vacío, no hacemos nada
        // (las refs se cargan desde handleSelectSupplier al seleccionar proveedor)
        if (!refSearchTerm.trim()) {
            return;
        }

        const handler = setTimeout(() => {
            // Reiniciamos la paginación y cargamos desde la página 1
            setSupplierRefs([]); 
            fetchReferencesForSupplier(selectedSupplier.value, 1, refSearchTerm);
        }, 350); 

        return () => {
            clearTimeout(handler);
        };
    }, [refSearchTerm, selectedSupplier]);

    // Datos validacion para la API
    const apiKey = () => {
        const cookies = new Cookies();
        const idSesion = getDecodedCookie('sesion');
        const sesion = getDecodedCookie('id');
        const validacion = { "sesion": idSesion, "id": sesion };

        return JSON.stringify(validacion);
    }

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                const url = `${getApiUrl(window.location.origin)}/agentes/getAllSuppliers`;
                const response = await axios.post(url, data);              
                // Asegurarse de que la respuesta sea un array
                if (Array.isArray(response.data)) {
                    setAllSuppliers(response.data);
                } else {
                    console.warn("La respuesta de la API de proveedores no es un array:", response.data);
                    setAllSuppliers([]); // Establecer un array vacío si no es válido
                }
            } catch (error) {
                console.error("Error al cargar los proveedores:", error);
                setAllSuppliers([]); // Manejar el error
            }
        };

        fetchSuppliers();
    }, []);



    const isEnabled = !!articleId;

    // Cargar las referencias de proveedores guardadas cuando cambia el articleId
    useEffect(() => {
        const fetchReferences = async () => {
            if (articleId) {
                try {
                    const data = new FormData();
                    data.append("validacion", apiKey());
                    data.append("iduni", articleId);

                    const url = `${getApiUrl(window.location.origin)}/articulos/getSuppliersFromArticle`;
                    const response = await axios.post(url, data);

                    if (Array.isArray(response.data)) {
                        const transformedReferences = response.data.map(ref => ({
                            id: ref.idage,
                            supplierId: ref.idage,
                            supplierName: ref.supplierName,
                            cod: ref.cod,
                            nom: ref.nom || '',
                            articleId: ref.iduni,
                            sap: ref.sap
                        }));
                        setSupplierReferences(transformedReferences);
                    } else {
                        setSupplierReferences([]);
                    }
                } catch (error) {
                    console.error("Error al cargar las referencias de proveedores:", error);
                    setSupplierReferences([]);
                }
            } else {
                setSupplierReferences([]);
            }
            handleCancelEdit();
        };

        fetchReferences();
    }, [articleId]);

    // Manejador del buscador
    const handleSearchChange = (e) => {       
        setSearchTerm(e.target.value);
        setSelectedSupplier(null); // Resetear selección si escribe de nuevo
        setShowSuggestions(true);
        setRefSearchTerm('');
    };

    const handleSelectSupplier = (supplier) => {
        setSearchTerm(supplier.label);
        setSelectedSupplier(supplier);
        setShowSuggestions(false);
        // Reiniciar y cargar la primera página de referencias
        setSupplierRefs([]);
        setRefPage(1);
        setRefSearchTerm(''); // Limpiamos el buscador de referencias
        fetchReferencesForSupplier(supplier.value, 1, ''); // Pasamos un string vacío para cargar todas
    };

    
    const fetchReferencesForSupplier = async (supplierId, page, searchTerm = '') => {
        if (!supplierId || (isRefLoading && page === 1)) return;
        setIsRefLoading(true);
        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("supplierId", supplierId);
            data.append("page", page);
            data.append("perPage", 25);
            if (searchTerm) {
                data.append("searchTerm", searchTerm); // Enviamos el término de búsqueda
            }
            const url = `${getApiUrl(window.location.origin)}/articulos/getReferencesFromSupplier`;
            const response = await axios.post(url, data);
            if (response.data.success) {
                const newRefs = (response.data.data || []).map(item => ({
                    id: item.cod2,
                    cod: item.cod2,
                    nom: ''
                }));
                
                setSupplierRefs(prev => page === 1 ? newRefs : [...prev, ...newRefs]);
                setTotalRefPages(response.data.pagination.totalPages);
                setRefPage(page);
            } else {
                if (page === 1) setSupplierRefs([]);
            }
        } catch (error) {
            console.error("Error al cargar las referencias del proveedor:", error);
            if (page === 1) setSupplierRefs([]);
        } finally {
            setIsRefLoading(false);
        }
    };

    // Filtrar sugerencias de proveedores
    const filteredSuppliers = Array.isArray(allSuppliers) ? allSuppliers.filter(s => {
        if (!s) return false;    
        const term = searchTerm.toLowerCase();
        const labelMatch = s.label && s.label.toLowerCase().includes(term);
        const sapMatch = s.sap && String(s.sap).toLowerCase().includes(term);
        return labelMatch || sapMatch;
    }) : [];

    // --- LÓGICA DEL BUSCADOR DE REFERENCIAS ---
    const handleRefSearchChange = (e) => {
        const newSearchTerm = e.target.value;
        setRefSearchTerm(newSearchTerm);
        setShowRefSuggestions(true);
        setSelectedRef(null);
        setReferenceValue(newSearchTerm);
        if (!newSearchTerm) {
            setDescriptionValue('');
        }
    };

    const handleSelectRef = async (ref) => {
        setRefSearchTerm(ref.cod); 
        setSelectedRef(ref);
        setReferenceValue(ref.cod);
        setDescriptionValue('Cargando...');
        setShowRefSuggestions(false);

        try {
            const data = new FormData();
            data.append("validacion", apiKey());
            data.append("reference", ref.cod);
            
            const url = `${getApiUrl(window.location.origin)}/articulos/getGenericFromReference`;
            const response = await axios.post(url, data);
            if (response.data && response.data.success && response.data.data?.nom1) {
                setDescriptionValue(response.data.data.nom1);
            } else {
                setDescriptionValue('');
            }
        } catch (error) {
            console.error("Error al obtener descripción:", error);
            setDescriptionValue('');
        }
    };

    // Añadir o actualizar proveedor en la lista
    const handleSaveSupplierReference = async () => {
        if (!selectedSupplier || !referenceValue.trim()) {
            swal("Error", "Por favor, complete todos los campos requeridos.", "error");
            return;
        }

        // --- VALIDACIÓN DE REFERENCIA DUPLICADA PARA EL MISMO PROVEEDOR ---
        const trimmedReference = referenceValue.trim().toLowerCase();
        const isDuplicateReference = supplierReferences.some(ref => {
            if (String(ref.supplierId) === String(selectedSupplier.value)) {
                return ref.cod.toLowerCase() === trimmedReference;
            }
            return false;
        });

        if (isDuplicateReference) {
            swal("Error", "Esta referencia ya existe para este proveedor.", "error");
            return;
        }

        try {
            if (editingId) {
                // --- LÓGICA DE ACTUALIZACIÓN ---
                const payload = {
                    iduni: articleId,
                    idage: editingId,
                    newIdage: selectedSupplier.value, // Nuevo ID de proveedor (puede ser el mismo)
                    cod: referenceValue,
                    nom: descriptionValue,
                };

                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("payload", JSON.stringify(payload));

                const url = `${getApiUrl(window.location.origin)}/articulos/addSupplierReference`; // este endpoint guarda o actualiza
                const response = await axios.post(url, data);

                if (response.data && response.data.success !== false) {
                    const updatedEntry = {
                        id: editingId,
                        supplierId: selectedSupplier.value,
                        supplierName: selectedSupplier.label,
                        cod: referenceValue,
                        nom: descriptionValue,
                        articleId: articleId
                    };
                    setSupplierReferences(supplierReferences.map(item =>
                        item.id === editingId ? updatedEntry : item
                    ));
                    swal("Actualizado", "La referencia del proveedor ha sido actualizada.", "success");
                    if (onUpdate) onUpdate();
                } else {
                    swal("Error", response.data.message || "No se pudo actualizar la referencia.", "error");
                }

            } else {
                // --- LÓGICA DE CREACIÓN ---
                const payload = {
                    iduni: articleId,
                    idage: selectedSupplier.value,
                    cod: referenceValue,
                    nom: descriptionValue,
                };

                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("payload", JSON.stringify(payload));

                const url = `${getApiUrl(window.location.origin)}/articulos/addSupplierReference`;
                const response = await axios.post(url, data);

                if (response.data && response.data.success !== false) {
                    const tempId = `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
                    const newEntry = {
                        id: tempId,
                        supplierId: selectedSupplier.value,
                        supplierName: selectedSupplier.label,
                        cod: referenceValue,
                        nom: descriptionValue,
                        articleId: articleId
                    };
                    setSupplierReferences([...supplierReferences, newEntry]);
                    swal("Guardado", "La referencia del proveedor ha sido añadida.", "success");
                    if (onUpdate) onUpdate();
                } else {
                    swal("Error", response.data.message || "No se pudo guardar la referencia.", "error");
                }
            }
            handleCancelEdit(); // Resetear formulario en ambos casos
        } catch (error) {
            console.error("Error al guardar la referencia del proveedor:", error);
            swal("Error", "Ocurrió un problema al conectar con el servidor.", "error");
        }
    };

    // Cargar datos en el formulario para editar
    const handleEdit = (item) => {
        setEditingId(item.id); // Guardamos el ID único del registro
        setSearchTerm(item.supplierName);        
        const supplier = allSuppliers.find(s => String(s.value) === String(item.supplierId)) || { value: item.supplierId, label: item.supplierName, sap: item.sap };        
        setSelectedSupplier(supplier);
        setReferenceValue(item.cod);
        setRefSearchTerm(item.cod);
        setDescriptionValue(item.nom || '');
    };

    // Cancelar edición
    const handleCancelEdit = () => {
        setEditingId(null);
        setSearchTerm('');
        setSelectedSupplier(null);
        setReferenceValue('');
        setDescriptionValue('');
        // --- LIMPIEZA ADICIONAL ---
        setRefSearchTerm('');
        setSelectedRef(null);
        setSupplierRefs([]);
        // Limpieza de paginación
        setRefPage(1);
        setTotalRefPages(1);
    };

  
    const handleDelete = async (idageToDelete) => {

        const willDelete = await swal({
            title: "¿Estás seguro?",
            text: "Una vez eliminada, no podrás recuperar esta referencia.",
            icon: "warning",
            buttons: ["Cancelar", "Eliminar"],
            dangerMode: true,
        });

        if (willDelete) {
            try {
                const data = new FormData();
                data.append("validacion", apiKey());
                data.append("idage", idageToDelete);
                data.append("iduni", articleId);

                const url = `${getApiUrl(window.location.origin)}/articulos/deleteSupplier`;
                const response = await axios.post(url, data);

                if (response.data && response.data.success) {
                    setSupplierReferences(supplierReferences.filter(ref => ref.id !== idageToDelete));
                    swal("Eliminado", "La referencia ha sido eliminada con éxito.", "success");
                    if (onUpdate) onUpdate();
                } else {
                    swal("Error", response.data.message || "No se pudo eliminar la referencia.", "error");
                }
            } catch (error) {
                console.error("Error al eliminar la referencia:", error);
                swal("Error", "Ocurrió un problema al conectar con el servidor.", "error");
            }
        }
    }
    return (
        <Container fluid className="mt-3">
            {isEnabled && supplierReferences.length > 0 && (
                <div className="mb-4">
                    <h5>Proveedores Asociados</h5>
                    <Table striped bordered hover size="sm" className="w-400">
                        <thead>
                            <tr>
                                <th>Proveedor</th>
                                <th>Referencia</th>
                                <th>Descripción</th>
                                <th style={{ width: '120px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {supplierReferences.map((item) => (

                                <tr key={item.id}>
                                    <td>{item.supplierName}</td>
                                    <td>{item.cod}</td>
                                    <td>
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id={`tooltip-description-${item.id}`}>{item.nom}</Tooltip>}
                                        >
                                            <span className="d-inline-block text-truncate" style={{ maxWidth: '300px' }}>
                                                {item.nom}
                                            </span>
                                        </OverlayTrigger>
                                    </td>
                                    <td>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            className="me-2"
                                            onClick={() => handleEdit(item)}
                                            title="Editar"
                                            disabled={!!editingId}
                                        >
                                            <i className="fas fa-edit"></i>
                                        </Button>
                                        <Button
                                            variant="outline-danger"
                                            size="sm"
                                            onClick={() => handleDelete(item.id)}
                                            title="Eliminar"
                                            disabled={!!editingId}
                                        >
                                            <i className="fas fa-trash-alt"></i>
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}
            <div className='mt-4 p-3 border rounded bg-light'>
                <h5 className="mb-3">{editingId ? 'Editar Proveedor' : `Añadir Proveedor`}</h5>
                <Form>
                    <Row className="mb-3">
                        <Col md={4} className="position-relative">
                            <Form.Group controlId="supplierSearch">
                                <Form.Label>Buscar Proveedor</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={isEnabled ? "Escribe para buscar..." : "Seleccione un artículo primero"}
                                    value={searchTerm}
                                    onChange={handleSearchChange}
                                    disabled={!isEnabled}
                                    autoComplete="off"
                                />
                                {/* Lista de sugerencias (simulando dropdown) */}
                                {showSuggestions && searchTerm && filteredSuppliers.length > 0 && (
                                    <ListGroup className="position-absolute w-100" style={{ zIndex: 1000, maxHeight: '200px', overflowY: 'auto', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                                        {filteredSuppliers.map(s => (
                                            <ListGroup.Item
                                                key={s.value}
                                                action
                                                onClick={() => handleSelectSupplier(s)}
                                            >
                                                {s.sap ? `${s.label} (SAP: ${s.sap})` : s.label}
                                            </ListGroup.Item>
                                        ))}
                                    </ListGroup>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={4} className="position-relative">
                            <Form.Group controlId="supplierReference">
                                <Form.Label>Referencia del Proveedor</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={selectedSupplier ? "Escribe para buscar o añadir..." : "Seleccione un proveedor"}
                                    value={refSearchTerm}
                                    onChange={handleRefSearchChange}
                                    disabled={!isEnabled || !selectedSupplier}
                                    autoComplete="off"
                                />
                                {showRefSuggestions && selectedSupplier && (
                                    <ListGroup className="position-absolute w-100" style={{ zIndex: 999, maxHeight: '250px', overflowY: 'auto' }}>
                                        {isRefLoading && refPage === 1 && (
                                            <ListGroup.Item className="text-center">
                                                <Spinner animation="border" size="sm" /> Buscando...
                                            </ListGroup.Item>
                                        )}
                                        {!isRefLoading && supplierRefs.length === 0 && refSearchTerm && (
                                            <ListGroup.Item disabled>No se encontraron referencias</ListGroup.Item>
                                        )}
                                        {supplierRefs.map(ref => (
                                            <ListGroup.Item
                                                key={ref.id}
                                                action
                                                onClick={() => handleSelectRef(ref)}
                                            >
                                                {ref.cod}
                                            </ListGroup.Item>
                                        ))}
                                        {/* Botón para cargar más resultados */}
                                        {!isRefLoading && refPage < totalRefPages && (
                                            <ListGroup.Item action onClick={() => fetchReferencesForSupplier(selectedSupplier.value, refPage + 1, refSearchTerm)} className="text-center text-primary">
                                                Cargar más...
                                            </ListGroup.Item>
                                        )}
                                        {isRefLoading && refPage > 1 && (
                                            <ListGroup.Item className="text-center">
                                                <Spinner animation="border" size="sm" /> Cargando...
                                            </ListGroup.Item>
                                        )}
                                    </ListGroup>
                                )}
                            </Form.Group>
                        </Col>
                        <Col md={4}>
                            <Form.Group controlId="supplierDescription">
                                <Form.Label>Descripción</Form.Label>
                                <Form.Control                              
                                    placeholder="Indique una referencia"
                                    maxLength={255}
                                    value={descriptionValue}
                                    onChange={(e) => setDescriptionValue(e.target.value)}
                                    disabled={!isEnabled || !selectedSupplier}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="mt-2">
                        {editingId ? (
                            <>
                                <Button
                                    variant="success"
                                    onClick={handleSaveSupplierReference}
                                    disabled={!isEnabled || !selectedSupplier || !referenceValue}
                                    className="me-2"
                                >
                                    <i className="fas fa-save me-1"></i> Actualizar
                                </Button>
                                <Button
                                    variant="secondary"
                                    onClick={handleCancelEdit}
                                >
                                    Cancelar
                                </Button>
                            </>
                        ) : (
                            <Button
                                variant="outline-success"
                                onClick={handleSaveSupplierReference}
                                disabled={!isEnabled || !selectedSupplier || !referenceValue}
                            >
                                <i className="fas fa-plus"></i>
                            </Button>
                        )}
                    </div>
                </Form>
            </div>
        </Container>
    );
}

export default SupplierReferences;